import React from "react";
import NumberFormat from "react-number-format";

export default function FormNumber({
  value,
  onValueChange,
  style,
  suffix,
  className,
  id,
  error,
}) {
  return (
    <>
      <div
        className={`d-flex align-items-center ${className}`}
        style={{ position: "relative" }}
      >
        <NumberFormat
          value={value}
          isNumericString={true}
          onValueChange={onValueChange}
          thousandSeparator={"."}
          decimalSeparator={","}
          style={{ ...style, borderColor: error ? "red" : null }}
          name={id}
        />
        {suffix && (
          <div
            style={{
              color: "#000",
              paddingRight: 20,
              position: "absolute",
              maxWidth: "100%",
              right: 0,
            }}
          >
            {suffix}
          </div>
        )}
      </div>
      {error && <p className="text-danger small">{error}</p>}
    </>
  );
}
